/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Cancel_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not cancel the scheduled change." |
*
* @param {Partner_Manage_Cancel_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_cancel_error = /** @type {((inputs?: Partner_Manage_Cancel_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Cancel_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geplante Änderung konnte nicht abgebrochen werden.")
	return /** @type {LocalizedString} */ ("Could not cancel the scheduled change.")
});